'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _adapters = require('../adapters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    id: 'net.authorize',

    form: [{ type: 'string', name: 'login' }, { type: 'string', name: 'transactionKey' }],

    // @see http://www.authorize.net/international/
    countries: ['AD', 'AT', 'AU', 'BE', 'BG', 'CA', 'CH', 'CY', 'CZ', 'DE', 'DK', 'ES', 'FI', 'FR', 'GB', 'GI', 'GR', 'GU', 'HU', 'IE', 'IT', 'LI', 'LU', 'MC', 'MT', 'NL', 'NO', 'NZ', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK', 'SM', 'US', 'VA'],

    fields: [],

    formValuesToMerchant: _adapters.simpleFormValuesToMerchant,
    merchantToFormValues: _adapters.simpleMerchantToFormValues,
    keyToMerchant: JSON.parse,
    merchantToKey: _stringify2.default,

    ranking: 4
};